import { MODE_DEV, MODE_PROD } from 'root/settings'
import { getSchema } from '../utils'

export const STORE_EMPLOYEES = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            status: 'status'
        }),
        [MODE_PROD]: Object.freeze({
            status: 's'
        })
    })
})()

export const STORES = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt',
            postalCodes: 'postalCodes',
            storeOwnerId: 'storeOwnerId',
            storeEmployees: 'storeEmployees',
            courierId: 'courierId',
            notificationToken: 'notificationToken',
            visibility: 'visibility',
            approval: 'approval',
            lastVisibilityUpdate: 'lastVisibilityUpdate',
            lastApprovalUpdate: 'lastApprovalUpdate',
            lastMetricUpdate: 'lastMetricUpdate',
            currentCloseTime: 'currentCloseTime',
            timezone: 'timezone',
            brandId: 'brandId',
            provinceId: 'provinceId'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'ca',
            postalCodes: 'pc',
            storeOwnerId: 'soi',
            storeEmployees: 'se',
            courierId: 'ci',
            notificationToken: 'nt',
            visibility: 'v',
            approval: 'a',
            lastVisibilityUpdate: 'lvu',
            lastApprovalUpdate: 'lau',
            lastMetricUpdate: 'lmu',
            currentCloseTime: 'cct',
            timezone: 'tz',
            brandId: 'bi',
            provinceId: 'pi'
        })
    })
})()
